angular.module('dpw.components')
    /**
     * @ngdoc directive
     * @name dpwEmailValidator
     * @restrict A
     * @require ngModel
     * @param {String} emailBlackList - If to check email with pre-defined email list.
     * @description
     * Add email validator to ngModel.
     * @example
     * <input ng-model="$ctrl.email" dpw-email-validator />
     * <input ng-model="$ctrl.email" dpw-email-validator email-black-list />
     */
    .directive('dpwEmailValidator', [function () {
            return {
                restrict: 'A',
                require: 'ngModel',
                scope: {},
                link: function (scope, element, attrs, ngModel) {
                    var validEmailPattern =  /^[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
                    var validateWithBlackList = 'emailBlackList' in attrs;

                    ngModel.$validators.dpwEmailValidator = function (modelValue, viewValue) {
                        var value = modelValue || viewValue;
                        return validEmailPattern.test(value) &&
                            (validateWithBlackList ? isDomainValid(value) : true);
                    };

                    function isDomainValid (value) {
                        var invalidDomains = [
                            /^test.com$/i,
                            /^example.com$/i,
                            /^1.com$/i,
                            /^2.com$/i
                        ];
                        var domain = value.split('@')[1];
                        return _.every(invalidDomains, function (invalidDomain) {
                            return !invalidDomain.test(domain);
                        });
                    }
                }
            };
        }]
    );